import React, { useState, useEffect } from 'react'
import clsx from 'clsx';
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
} from '@material-ui/core';
import AsyncButton from 'utils/AsyncButton';
import { makeStyles } from '@material-ui/styles';
import { fetchUsers } from 'api/users';
import MaybeLoading from 'utils/MaybeLoading';
import ModalWrapper from 'components/ModalWrapper'
import UserRegistrationModal from './UserRegistrationModal'
import UserEditorModal from './UserEditorModal'
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { DEFAULT_ERROR_MESSAGE } from '../../../const'

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
  },
  inner: {
    minWidth: 1050,
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  actions: {
    backgroundColor: '#fafafa',
    position: 'relative',
    height: '60px',
    borderBottom: '1px solid #eeeeee',
  },
  pagenation: {
    position: 'absolute',
    right: 0,
  },
  tableRow: {
    cursor: 'pointer',
    padding: '12px',
    whiteSpace: 'pre-wrap',
  },
  table: { padding: '12px' },
  addButton: {
    marginRight: "10px",
  },
  buttonArea: {
    justifyContent: 'flex-end',
    position: 'relative',
    backgroundColor: '#fafafa',
    height: '60px',
    borderBottom: '1px solid #eeeeee',
  },
  leftButtonArea: { position: 'absolute', left: 0, marginLeft: 15 },
  rightButtonArea: { position: 'absolute', right: 0, marginRight: 15 },
  button: { marginRight: 5, marginLeft: 5 },
  tableTopButton: { marginRight: 5 }
}));

const UserTable = () => {
  const classes = useStyles();
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [isUserRegistrationModalOpen, setIsUserRegistrationModalOpen] = useState(false)
  const [isUserEditorModalOpen, setIsUserEditorModalOpen] = useState(false)
  const [selectedUser, setSelectedUser] = useState()
  const fetchData = async (currentPage, perPage) => {
    setLoading(true)
    await fetchUsers(currentPage, perPage)
      .then(({ users, totalCount }) => {
        setUsers(users)
        setCount(totalCount)
        setLoading(false)
      })
      .catch((err) => {
        console.error(err)
        alert(DEFAULT_ERROR_MESSAGE)
      })
  }

  useEffect(() => {
    fetchData(page, rowsPerPage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handlePageChange = (_, page) => {
    setPage(page)
    fetchData(page, rowsPerPage)
  }

  const handleRowsPerPageChange = (event) => {
    setPage(0)
    setRowsPerPage(event.target.value)
    fetchData(0, event.target.value)
  }

  const handleRowClick = (user) => {
    setSelectedUser(user)
    setIsUserEditorModalOpen(true)
  }

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Card className={clsx(classes.root)}>
          <CardActions className={classes.buttonArea}>
            <AsyncButton
              className={classes.addButton}
              type="button"
              variant="contained"
              color="primary"
              onClick={() => {
                setIsUserRegistrationModalOpen(true)
              }}
              loading={false}
            >
              追加
            </AsyncButton>
          </CardActions>
          <CardActions className={classes.actions}>
            <TablePagination
              className={classes.pagenation}
              component='div'
              count={count}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[10, 20, 50, 100, 200]}
            />
          </CardActions>
          <CardContent className={classes.content}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ユーザー名</TableCell>
                  <TableCell>メールアドレス</TableCell>
                  <TableCell>権限</TableCell>
                  <TableCell>作成日</TableCell>
                  <TableCell>更新日</TableCell>
                </TableRow>
              </TableHead>
              <MaybeLoading
                loading={loading}
                progressComponent={
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={10}>
                        <Grid container alignItems="center" justify="center">
                          <Grid item>
                            <CircularProgress />
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                }
              >
                <TableBody>
                  {users.map((user, index) => (
                    <TableRow key={index} onClick={() => handleRowClick(user)}>
                      <TableCell>{user.userName}</TableCell>
                      <TableCell>{user.cognitoEmail}</TableCell>
                      <TableCell>{user.groupName}</TableCell>
                      <TableCell>{user.createdAt}</TableCell>
                      <TableCell>{user.updatedAt}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </MaybeLoading>
            </Table>
          </CardContent>
          <CardActions className={classes.actions}>
            <TablePagination
              className={classes.pagenation}
              component='div'
              count={count}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[10, 20, 50, 100, 200]}
            />
          </CardActions>
        </Card>
        <ModalWrapper
          open={isUserRegistrationModalOpen}
          handleClose={() => setIsUserRegistrationModalOpen(false)}
          scroll={true}
          content={<UserRegistrationModal closeModal={() => setIsUserRegistrationModalOpen(false)} />}
        />
        <ModalWrapper
          open={isUserEditorModalOpen}
          handleClose={() => setIsUserEditorModalOpen(false)}
          scroll={true}
          content={
            <UserEditorModal
              closeModal={() => setIsUserEditorModalOpen(false)}
              selectedUser={selectedUser}
            />
          }
        />
      </div>
    </div>
  )
}

export default UserTable
